import React, { Component } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

export default function NavCard({ icon = null, name = '', link = '', key, type }) {
    const {t}=useTranslation();
    return (
        <NavLink
            activeClassName='nav-card-selected'
            key={key}
            to={link}
            className='nav-card '>
            <img src={icon} />
            {type === 'selected' ?<span>{t(name)}</span> : <h2>{t(name)}</h2>}
        </NavLink>
    )
}